
























































































import { Component, Vue } from "vue-property-decorator";
import Home from "./components/Home.vue";
import { detect } from "detect-browser";

const browser = detect();

@Component({
  components: {
    Home
  }
})
export default class Site extends Vue {
  get pluginUrl() {
    return browser && browser.name !== "chrome" && browser.type === "browser"
      ? "/gastrosurf.xpi"
      : "https://chrome.google.com/webstore/detail/gastrosurf/nkjjgdfoopmhonghmffegjnpnbglhejn";
  }

  get target() {
    return browser && browser.name !== "chrome" ? "_self" : "_blank";
  }
}
